import React from 'react';

// import { connect } from "react-redux"
// import { priceTypeSlashed } from "../../helpers/app_constant";
// import Currency from '../Currency';

// import {
// 	Price,
// 	OfferPrice,
// 	CrossedText,
// } from './style';

export const calculatePriceWithTax = ({ price, is_back_calculate_tax, tax = 5, shouldRoundOff = true }:any) => {
	const tax_factor = (1 + (tax / 100));
	let displayPrice = parseFloat(price).toFixed(2);
	if (is_back_calculate_tax !== 1) {
		displayPrice = parseFloat((price * tax_factor).toString()).toFixed(2);
	}

	if (!shouldRoundOff){
		return parseFloat(displayPrice)
	}
	
	return Math.round(parseFloat(displayPrice));
};


export const getTaxValue = (tax_category:number, tax_categories_mapping:any, store_tax = 5) => {
	if (!tax_categories_mapping){
		return store_tax;
	}
	const curr_tax_mappings = tax_categories_mapping.filter((t:any) => t.tax_category === tax_category);
	const tax = curr_tax_mappings.map((t:any) => parseFloat(t.value)).reduce((a:number,b:number) => a + b, 0);
	return tax;
}


// export const getComboPrice = (comboObj, taxCategories, storeTax) => {
// 	let comboPrice = 0;
// 	if (!comboObj.sets){
// 		return comboPrice;
// 	}
	
// 	comboObj.sets.forEach(set => {
// 		const { set_price, is_back_calculate_tax, tax_category } = set;
// 		const setTax = getTaxValue(tax_category, taxCategories, storeTax);
// 		comboPrice += calculatePriceWithTax({ price: set_price, tax:setTax, is_back_calculate_tax , shouldRoundOff: false })
// 	})
// 	return Math.round(comboPrice);
// }


// const ProductPrice = ({ product, home, type, unit , freeproduct }:any) => {
// 	const tax_categories = home?.nearestStore?.tax_categories || home?.nearestStore?.taxCategories;
// 	const store_tax = home?.nearestStore?.tax;
// 	const productTax = getTaxValue(product.tax_category, tax_categories, store_tax);
// 	const { price, cart_display_price, offer_price, coupon_offer_price, is_back_calculate_tax, quantity } = product;
	
// 	const quantityToShow = (unit ? 1 : quantity) || 1
// 	const priceToShow = calculatePriceWithTax({ price: price || cart_display_price, is_back_calculate_tax, tax: productTax }) * quantityToShow;
// 	const couponOfferPriceToShow = coupon_offer_price
// 	const offerPriceToShow = calculatePriceWithTax({ price: offer_price, is_back_calculate_tax , tax: productTax });

// 	// Calculate customization price
// 	let totalPrice = priceToShow;
// 	let customizationPrice = 0;
	
// 	if (product.customisations_groups){
// 		product.customisations_groups.forEach((group:any) => {
// 			group.customisations.forEach((customisation:any) =>{
// 				const { price, is_back_calculate_tax } = customisation;
// 				const customizationTax = getTaxValue(customisation.tax_category, tax_categories, store_tax);
// 				customizationPrice += calculatePriceWithTax({ price, is_back_calculate_tax , tax: customizationTax })
// 			})
// 		})
// 		let totalCustomizationPrice = customizationPrice * quantityToShow;
// 		totalPrice = priceToShow + totalCustomizationPrice;
// 	}
// 	else if (product.sets){
// 		product.sets.forEach((set:any) => {
// 				set.products[0]?.customisations_groups?.forEach((group:any) => {
// 					group.customisations.forEach((customisation:any) =>{
// 						const { price, is_back_calculate_tax } = customisation;
// 						const customizationTax = getTaxValue(customisation.tax_category, tax_categories, store_tax);
// 						customizationPrice += calculatePriceWithTax({ price, is_back_calculate_tax , tax:customizationTax })
// 					})
// 				})
// 		})
// 		let totalCustomizationPrice = customizationPrice * quantityToShow;
// 		totalPrice = getComboPrice(product, tax_categories, store_tax) + totalCustomizationPrice;
// 	}
	

// 	if (type === priceTypeSlashed){
// 		return (
// 			<OfferPrice className={priceTypeSlashed && "priceTypeSlashed"}>
// 				<Currency home={home} />
// 				{type === priceTypeSlashed && renderSlashedPrice(totalPrice)}
// 				<Currency home={home} />
// 				{couponOfferPriceToShow || offerPriceToShow}
// 			</OfferPrice>
// 		)
// 	}


	
	
// 	return (
// 		<>
// 			{freeproduct ? (
// 				<CrossedText className="priceContainer">
// 					<PriceWrapper totalPrice={totalPrice} home={home} /> 
// 					<abbr>
// 						<Currency home={home} /> {0}
// 					</abbr>
// 				</CrossedText>
// 			) : <PriceWrapper totalPrice={totalPrice} home={home} /> 
// 			}
// 		</>
// 	);
// }
 
// const PriceWrapper = ({ totalPrice, home }) => {
// 	return (
// 		<span className="price-label">
// 			<Currency home={home} />
// 			{totalPrice}
// 		</span>
// 	)
// }

// const renderSlashedPrice = (offerPriceToShow, home) => (
// 	<Price>
// 		<Currency home={home} />
// 		{offerPriceToShow}
// 	</Price>
// );

// const mapStateToProps = (state) => ({ home:state.home });
// export default connect(mapStateToProps)(ProductPrice);